<script setup lang="ts">
  import LoginForm from '@/features/Auth/ui/LoginForm.vue';
  import LogoSection from '@/shared/ui/branding/LogoSection.vue';
</script>

<template>
  <div class="flex flex-row w-screen h-screen">
    <section
      id="login"
      class="text-gray-07 text-left w-1/2 pr-40 flex flex-col items-center justify-center"
    >
      <LoginForm />
    </section>
    <LogoSection title="Gestor de Documentos 2.0" />
  </div>
</template>
